import React, { Component } from 'react';

class AICatTermsOfUse extends Component {

  render() {
    return (
      <div style={{ padding: '20px', color: 'white'}}>
        <h1>Terms of Use</h1>
        <p>Last Updated: 2023.04.15</p>

        <p>
        Before purchasing AICat Premium, you are strongly encouraged to read our Terms of Service as below
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Subscription</b>
        <br/>
        <br/>
        We are using the subscription model to manage premium user membership, it is available as monthly subscription now
        <br/>
        <br/>
        The monthly subscription automatically renews and you account will be charged unless auto-renew is turned off at least 24 hours before the end of the current subscription period
        <br/>
        <br/>
        AICat provide one option to unlock Pro features:
        <br/>
        <br/>
        <li>AICat Premium Monthly (Billing every month, you can cancel it at any time)</li>
        <br/>
        <br/>
        You are able to manage your subscriptions on the <a href="https://apps.apple.com/account/subscriptions">App Store</a> at any time
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>AICat Premium Features</b>
        <br/>
        <br/>
        We provide unlimited features for AICat Premium users:
        <br/>
        <br/>
        <li>Answers from GPT Model</li>
        <li>No limits for Dialogues</li>
        <li>Higher word limit</li>
        <li>Get new features first</li>
        <li>Unlimited custom prompts</li>
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Refund</b>
        <br/>
        <br/>
        We are sorry to hear that you want to refund, please <a href="mailto:iplay.coder@gmail.com">contact us</a> for your complains first, but we respect your choice. However, developers are not responsible for refunds, you are encouraged to contract Apple Support Team directly, some information could be found <a href="https://support.apple.com/en-us/HT204084">here</a>
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Changes to This Terms of Service</b>
        <br/>
        <br/>
        We may update our Terms of Service from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting new Terms of Service on this page. These changes are effective immediately after they are posted on this page.
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Contract Us</b>
        <br/>
        <br/>
        If you have any questions or suggestions about Terms of Service, do not hesitate to contact us at <a href="mailto:iplay.coder@gmail.com">iplay.coder@gmail.com</a>
        <br/>
        <br/>
        Thanks for choosing AICat!
        <br/>
        AICat Team
        <br/>
        </p>
      </div>
    );
  }
}

export default AICatTermsOfUse